<template>
  <div
    v-if="modalIsOpened"
    class="fixed inset-0 w-full bg-black/30"
    @click.self="closeModal"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[450px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div
          class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden"
        >
          <div class="flex flex-col p-[20px] pt-[12px] gap-[22px] bg-[#FCFCFC]">
            <div class="flex flex-col items-center">
              <ResourcesIcon class="w-[50px] h-[50px] text-[#9B237B]" />
              <span class="PC_Body1-SB !text-[#1F1D1F]"> ร้องขอทรัพยากร </span>
            </div>
            <div
              class="flex flex-col gap-[12px] px-[10px] py-[14px] rounded-[6px] border-[1px] border-solid border-[#b7b2b5] bg-[#fff]"
            >
              <div class="flex items-start gap-[6px]">
                <div
                  class="min-w-[48px] min-h-[48px] w-[48px] h-[48px] border-[1px] border-solid border-[#F2E7F9]"
                >
                  <img
                    :src="
                      item.image.image_path || 'https://placehold.co/48x48/png'
                    "
                    alt=""
                  />
                </div>
                <div>
                  <div class="PC_Body1-R !text-[#1F1D1F]">{{ item.name }}</div>
                  <div class="cardLabel">
                    {{ item.unit_name }}
                  </div>
                  <div class="cardLabel">
                    {{ item.category_name }}
                  </div>
                </div>
              </div>
              <div v-if="item.unit_type == 1" class="PC_Body2-R text-[#1F1D1F]">
                ทรัพยากรนี้ไม่สามารถระบุจำนวนได้
              </div>
              <div
                v-if="item.unit_type == 2"
                class="flex items-center gap-[6px] p-[4px] px-[6px] bg-[#FBEFF8] PC_Body2-R text-[#1F1D1F]"
              >
                <div>จำนวนภายในศูนย์</div>
                <div>:</div>
                <div>{{ $numberAndComma(item.quantity) || "0" }}</div>
              </div>
              <Radio
                v-if="item.unit_type == 2"
                :id="'resources_choice0'"
                v-model="form.choice"
                :name="'resources_choice0'"
                :value="0"
                :label="'ระบุจำนวนที่ต้องการ'"
                :quantitySelector="true"
                :fieldValue="form.request"
                @update:fieldValue="
                  (val) => {
                    form.request = val;
                  }
                "
              />
              <Radio
                v-if="item.unit_type == 2"
                :id="'resources_choice1'"
                v-model="form.choice"
                :name="'resources_choice1'"
                :value="1"
                :label="'ไม่ระบุจำนวน'"
              />
            </div>
            <div class="flex items-center justify-center gap-[10px]">
              <ButtonComponent
                :label="'ยกเลิก'"
                :bClass="'btn_shadow--cancel'"
                @clicked="closeModal"
              />
              <ButtonComponent
                :label="'ตกลง'"
                :bClass="'btn_shadow--save'"
                :disabled="form.choice == 0 && form.request == 0"
                @clicked="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useGlobals } from "@/components/Utilities/javascripts/useGlobals";
import { useProductStore } from "@/pinia/product";

const { $validateMsg } = useGlobals();
const productStore = useProductStore();
const input = {
  product_id: "",
  choice: 0,
  request: "0",
};
const form = ref({ ...input });
const errors = ref({ ...input });
const item = ref({});
const modalIsOpened = ref(false);

const emit = defineEmits(["status"]);

const openModal = (data) => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  form.value = {
    ...input,
  };
  errors.value = {
    ...input,
  };

  item.value = data;
  console.log("item", item.value);
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const save = async () => {
  const body = [
    {
      product_id: item.value.id,
      request:
        form.value.choice == 1 || item.value.unit_type == 1
          ? "-1"
          : form.value.request,
    },
  ];
  await productStore
    .createProductRequest(body)
    .then((response) => {
      if (response.status === 200) {
        emit("status", response.data.message, "success");
        closeModal();
      }
    })
    .catch((error) => {
      if (error.status === 400) {
        emit("status", error.response.data.message, "error");
      } else {
        $validateMsg(error.response.data.errors, errors.value);
      }
    });
};

defineExpose({ openModal });
</script>
    
<style lang="scss" scoped>
@media screen and (max-width: 64rem) {
  .PC_Body1-R {
    font-size: 16px !important;
  }
}
</style>